import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/images/mobile-menu/categories/128-motos-cascos.svg")